export const siteInfo = {
  name: '91.com',
  tagline: '官方入口与全功能导航指南',
  description: '91.com 是备受用户关注的综合性网络平台，提供官方入口导航、核心功能介绍、使用指南及常见问题解答，帮助用户快速找到91.com并安全高效地使用其全部服务。',
  url: 'https://91.com',
  logo: '91.com',
};

export const categories = [
  { slug: 'usage-guide', name: '使用指南', description: '91.com 详细使用教程与操作指引', icon: 'ri-book-open-line' },
  { slug: 'features', name: '功能介绍', description: '91.com 核心功能全面解析', icon: 'ri-apps-line' },
  { slug: 'faq', name: '常见问题', description: '91.com 常见问题与解决方案', icon: 'ri-question-line' },
  { slug: 'security', name: '安全访问', description: '91.com 安全访问与最新地址', icon: 'ri-shield-check-line' },
  { slug: 'news', name: '最新动态', description: '91.com 平台最新资讯与更新', icon: 'ri-flashlight-line' },
];

export const articles = [
  {
    id: 1,
    slug: '91-official-entrance-guide',
    title: '91.com 官方入口完整指南：快速找到并安全访问',
    excerpt: '本文详细介绍如何找到91.com的官方入口地址，以及如何安全高效地访问平台，避免误入仿冒网站。',
    category: 'usage-guide',
    date: '2026-07-28',
    readTime: '8分钟',
    content: `91.com 作为综合性网络平台，每天有大量用户通过它获取信息和服务。然而，很多新用户常常遇到找不到正确入口的问题。本文将为你提供最全面的官方入口指南。

## 为什么需要关注官方入口

随着91.com用户数量的不断增长，网络上出现了不少仿冒网站。这些仿冒网站不仅无法提供真实的服务，还可能存在安全风险。因此，找到并记住91.com的官方入口至关重要。

## 如何找到91.com官方入口

1. 直接访问域名：在浏览器地址栏直接输入91.com即可访问官方平台。
2. 搜索引擎验证：通过主流搜索引擎搜索"91.com官方入口"，点击带有官方标识的结果。
3. 收藏官方地址：将91.com添加到浏览器书签，方便下次快速访问。

## 安全访问建议

- 始终检查网址是否为91.com
- 注意浏览器地址栏的安全锁标识
- 不要在不明来源的链接中输入个人信息
- 定期更新浏览器到最新版本

## 常见访问问题排查

如果无法访问91.com，可以尝试以下方法：
- 检查网络连接是否正常
- 清除浏览器缓存和Cookie
- 尝试使用不同的浏览器
- 检查DNS设置是否正确`,
  },
  {
    id: 2,
    slug: '91-core-features-overview',
    title: '91.com 核心功能全景解析：一站式掌握全部服务',
    excerpt: '91.com 提供丰富的功能模块，涵盖资讯浏览、资源下载、社区互动等多个维度，本文将逐一解析。',
    category: 'features',
    date: '2026-07-25',
    readTime: '10分钟',
    content: `91.com 作为一个综合性网络平台，其功能覆盖面非常广泛。了解这些核心功能，可以帮助你更好地利用平台资源。

## 资源浏览与搜索

91.com 拥有海量的资源库，用户可以通过关键词搜索快速找到所需内容。平台支持多种搜索筛选方式，包括按类别、按时间、按热度等维度进行精准定位。

## 社区互动功能

平台内置了完善的社区系统，用户可以参与话题讨论、发布评论、与其他用户交流心得。社区氛围友好活跃，是获取最新资讯和分享经验的好去处。

## 个人中心管理

每位用户都拥有独立的个人中心，可以管理收藏内容、浏览历史、个人资料等。个人中心界面简洁直观，操作便捷。

## 通知与提醒

平台提供及时的消息通知功能，重要更新和互动消息都会第一时间推送给用户，确保不错过任何重要信息。

## 移动端适配

91.com 针对移动设备进行了全面优化，用户可以通过手机浏览器获得与桌面端一致的流畅体验。`,
  },
  {
    id: 3,
    slug: '91-registration-tutorial',
    title: '91.com 新用户注册与账号设置详细教程',
    excerpt: '从零开始教你如何在91.com完成注册、设置个人资料并开启全新的使用体验。',
    category: 'usage-guide',
    date: '2026-07-22',
    readTime: '6分钟',
    content: `如果你是91.com的新用户，本文将手把手教你完成注册和基本设置。

## 注册步骤

1. 打开91.com官方网站
2. 点击右上角的"注册"按钮
3. 填写必要的注册信息（用户名、密码、邮箱等）
4. 阅读并同意用户协议
5. 完成验证码验证
6. 点击"提交注册"完成注册

## 邮箱验证

注册完成后，系统会向你的注册邮箱发送验证邮件。请及时查收并点击验证链接，以激活你的账号。

## 个人资料设置

登录后，进入个人中心可以设置：
- 头像上传
- 昵称修改
- 个人简介
- 隐私设置

## 安全设置建议

- 设置高强度密码（包含大小写字母、数字和特殊字符）
- 绑定手机号以增强账号安全
- 开启二次验证功能
- 定期更换密码`,
  },
  {
    id: 4,
    slug: '91-security-access-guide',
    title: '91.com 安全访问全攻略：最新地址与防护技巧',
    excerpt: '全面了解91.com的安全访问机制，获取最新可用地址，掌握防钓鱼和隐私保护技巧。',
    category: 'security',
    date: '2026-07-20',
    readTime: '7分钟',
    content: `网络安全是每位91.com用户都应该重视的问题。本文汇总了安全访问91.com的所有必要知识。

## 官方地址确认

91.com 的唯一官方域名为 91.com。请认准此域名，任何变体或相似域名都可能是仿冒网站。

## 最新地址获取方式

- 关注91.com官方社交媒体账号
- 订阅官方邮件通知
- 加入官方用户社群
- 收藏本导航页面

## 防钓鱼指南

1. 不要点击来路不明的"91.com"链接
2. 检查网址拼写是否完全正确
3. 注意SSL证书是否有效
4. 不要在公共WiFi环境下登录

## 隐私保护建议

- 不要在公共场所保存登录状态
- 使用浏览器的隐私模式访问
- 定期清理浏览数据
- 谨慎授权第三方应用`,
  },
  {
    id: 5,
    slug: '91-search-tips',
    title: '91.com 高效搜索技巧：快速找到你需要的资源',
    excerpt: '掌握91.com的搜索技巧和高级筛选功能，大幅提升资源查找效率。',
    category: 'features',
    date: '2026-07-18',
    readTime: '5分钟',
    content: `91.com 的搜索功能非常强大，掌握以下技巧可以让你的查找效率翻倍。

## 基础搜索

在搜索框输入关键词，系统会自动匹配相关内容。支持中英文混合搜索。

## 高级筛选

使用高级筛选功能可以：
- 按上传时间排序
- 按文件类型筛选
- 按文件大小筛选
- 按热度排序

## 搜索技巧

1. 使用精确的关键词
2. 尝试不同的关键词组合
3. 使用排除词缩小范围
4. 利用分类标签辅助搜索`,
  },
  {
    id: 6,
    slug: '91-common-problems-solutions',
    title: '91.com 常见问题汇总：访问、登录、使用全解答',
    excerpt: '整理91.com用户最常遇到的问题及详细解决方案，覆盖访问异常、账号问题、功能使用等方方面面。',
    category: 'faq',
    date: '2026-07-15',
    readTime: '12分钟',
    content: `本文汇总了91.com用户在日常使用中遇到的各种常见问题，并提供详细的解决方案。

## 访问相关问题

**Q: 为什么打不开91.com？**
A: 可能原因包括网络问题、DNS解析异常、浏览器缓存等。建议逐一排查。

**Q: 页面加载很慢怎么办？**
A: 尝试切换网络环境，或清理浏览器缓存后重试。

## 账号相关问题

**Q: 忘记密码如何找回？**
A: 点击登录页面的"忘记密码"，按提示通过注册邮箱或手机号重置密码。

**Q: 账号被锁定怎么办？**
A: 通常因多次输入错误密码导致，等待15分钟后自动解锁，或联系客服处理。

## 功能使用问题

**Q: 如何收藏内容？**
A: 在内容页面点击收藏按钮即可，后续可在个人中心查看收藏列表。

**Q: 如何举报不良内容？**
A: 每个内容页面都有举报入口，点击后选择举报原因提交即可。`,
  },
  {
    id: 7,
    slug: '91-mobile-usage-guide',
    title: '91.com 移动端使用完全指南：随时随地畅享服务',
    excerpt: '详细介绍91.com在手机和平板设备上的使用方法和优化技巧。',
    category: 'usage-guide',
    date: '2026-07-12',
    readTime: '6分钟',
    content: `91.com 针对移动端进行了深度优化，让你随时随地都能畅享平台服务。

## 移动端访问方式

直接在手机浏览器中输入91.com即可访问移动版。平台会自动适配你的设备屏幕。

## 移动端特色功能

- 触屏优化界面，操作更便捷
- 节省流量的精简模式
- 手势操作支持
- 一键分享到社交平台

## 移动端使用技巧

1. 添加到主屏幕：通过浏览器菜单将91.com添加到手机桌面
2. 开启通知：及时获取最新动态
3. 夜间模式：保护视力，舒适浏览`,
  },
  {
    id: 8,
    slug: '91-platform-updates-2026',
    title: '91.com 2026年最新更新：新功能与优化一览',
    excerpt: '盘点91.com在2026年的重要更新，包括界面优化、新功能上线和性能提升等。',
    category: 'news',
    date: '2026-07-10',
    readTime: '8分钟',
    content: `2026年，91.com 进行了多项重要更新，用户体验得到显著提升。

## 界面全面升级

全新设计的用户界面更加简洁美观，导航更加直观，响应速度更快。

## 新增功能

- 智能推荐系统：根据用户偏好精准推送内容
- 多语言支持：新增多国语言界面
- 暗黑模式：保护视力的深色主题

## 性能优化

- 页面加载速度提升40%
- 搜索响应时间缩短50%
- 服务器稳定性增强`,
  },
  {
    id: 9,
    slug: '91-account-security-guide',
    title: '91.com 账号安全防护指南：保护你的数字资产',
    excerpt: '全方位教你如何保护91.com账号安全，防止被盗和信息泄露。',
    category: 'security',
    date: '2026-07-08',
    readTime: '9分钟',
    content: `账号安全是使用91.com的基础保障。本文将全面介绍账号安全防护措施。

## 密码管理

- 使用至少12位的复杂密码
- 不同平台使用不同密码
- 使用密码管理器辅助记忆
- 每3个月更换一次密码

## 二次验证

建议开启二次验证功能，即使密码泄露也能保护账号安全。

## 登录设备管理

定期检查并管理登录设备，及时移除不认识的设备。

## 异常登录提醒

开启异常登录提醒，第一时间发现并处理安全问题。`,
  },
  {
    id: 10,
    slug: '91-community-guidelines',
    title: '91.com 社区规范与使用礼仪：共建良好交流环境',
    excerpt: '了解91.com社区的行为规范和交流礼仪，共同维护健康积极的社区氛围。',
    category: 'faq',
    date: '2026-07-05',
    readTime: '7分钟',
    content: `良好的社区环境需要每位用户共同维护。以下是91.com社区的基本规范。

## 基本行为准则

1. 尊重他人，文明交流
2. 不发布违法和不良信息
3. 不进行人身攻击和恶意骚扰
4. 不发布广告和垃圾信息
5. 保护他人隐私

## 内容发布规范

- 确保发布内容的真实性和原创性
- 转载内容需注明来源
- 不发布未经证实的谣言

## 违规处理

违反社区规范的用户将根据情节轻重受到警告、限制功能或封禁账号等处理。`,
  },
  {
    id: 11,
    slug: '91-data-management',
    title: '91.com 数据管理功能详解：上传、下载与整理',
    excerpt: '深入了解91.com的数据管理功能，高效管理你的在线资源。',
    category: 'features',
    date: '2026-07-02',
    readTime: '6分钟',
    content: `91.com 提供了强大的数据管理功能，帮助用户高效组织和利用资源。

## 文件上传

支持多种格式文件上传，上传过程稳定可靠，支持断点续传。

## 文件管理

- 创建文件夹进行分类管理
- 批量操作：移动、删除、重命名
- 文件标签系统
- 版本历史记录

## 分享功能

- 生成分享链接
- 设置访问权限
- 设置有效期
- 查看下载统计`,
  },
  {
    id: 12,
    slug: '91-beginner-quick-start',
    title: '91.com 新手快速入门：10分钟掌握核心操作',
    excerpt: '专为新手打造的快速入门指南，10分钟带你熟悉91.com的核心操作流程。',
    category: 'usage-guide',
    date: '2026-06-28',
    readTime: '5分钟',
    content: `欢迎来到91.com！本文将在10分钟内帮你快速上手核心操作。

## 第一步：注册账号

访问91.com，点击注册，填写基本信息完成注册。

## 第二步：熟悉界面

注册后浏览首页，了解各个功能模块的位置和作用。

## 第三步：搜索内容

尝试使用搜索功能查找你感兴趣的内容。

## 第四步：互动体验

在感兴趣的内容下发表评论，与其他用户互动。

## 第五步：个性化设置

进入个人中心，根据偏好调整各项设置。`,
  },
];

export const faqItems = [
  {
    question: '91.com 是什么？',
    answer: '91.com 是一个综合性网络平台，为用户提供丰富的在线服务和资源。平台集成了资讯浏览、资源下载、社区互动等多种功能，致力于为用户提供便捷高效的一站式网络服务体验。',
  },
  {
    question: '如何安全访问 91.com？',
    answer: '请直接通过浏览器输入 91.com 访问官方平台。建议收藏官方地址，避免通过搜索引擎点击广告链接。同时注意检查网址是否正确，谨防仿冒网站。',
  },
  {
    question: '91.com 的账号如何注册？',
    answer: '访问91.com后，点击页面右上角的"注册"按钮，按照提示填写用户名、密码、邮箱等信息，完成验证后即可注册成功。注册后建议立即完善个人资料并开启安全设置。',
  },
  {
    question: '忘记密码怎么办？',
    answer: '在登录页面点击"忘记密码"链接，输入注册时使用的邮箱或手机号，系统会发送密码重置链接或验证码，按照提示即可重置密码。',
  },
  {
    question: '91.com 收费吗？',
    answer: '91.com 基础服务完全免费。部分高级功能可能需要付费使用，具体以平台公告为准。所有收费项目都会在显著位置标明。',
  },
  {
    question: '如何联系 91.com 客服？',
    answer: '您可以通过以下方式联系客服：1) 平台内的在线客服系统；2) 官方客服邮箱；3) 官方社交媒体账号。客服工作时间为工作日9:00-18:00。',
  },
  {
    question: '91.com 支持哪些设备访问？',
    answer: '91.com 支持在电脑（Windows/Mac/Linux）、平板和手机等各类设备上通过浏览器访问。平台针对不同设备都做了适配优化，提供流畅的使用体验。',
  },
  {
    question: '91.com 上的内容可靠吗？',
    answer: '91.com 平台上的内容经过审核机制筛查，但用户仍需自行判断内容的准确性。如发现不实或违规内容，可使用举报功能反馈给平台处理。',
  },
];

export const features = [
  {
    icon: 'ri-compass-3-line',
    title: '官方入口导航',
    description: '提供91.com官方入口直达链接，确保用户始终通过正确渠道访问平台，避免进入仿冒网站。',
  },
  {
    icon: 'ri-book-read-line',
    title: '使用指南',
    description: '涵盖从注册到高级功能的完整教程，图文并茂地指导用户掌握91.com的全部操作。',
  },
  {
    icon: 'ri-function-line',
    title: '功能介绍',
    description: '深度解析91.com各项功能的用途和优势，帮助用户发现并充分利用平台的全部能力。',
  },
  {
    icon: 'ri-question-answer-line',
    title: '常见问题',
    description: '整理用户最常遇到的问题并提供详细解答，快速解决使用过程中的各种疑惑。',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '安全防护',
    description: '提供账号安全设置指南和防钓鱼技巧，全方位保护用户的数字资产和隐私安全。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '完美适配电脑、平板和手机等多种设备，随时随地畅享91.com的全部服务。',
  },
];

export const stats = [
  { value: '500万+', label: '活跃用户' },
  { value: '10年+', label: '稳定运营' },
  { value: '99.9%', label: '服务可用率' },
  { value: '24/7', label: '安全防护' },
];